import { navigate } from '../router.js';
import { isAuthenticated, onAuthChange } from '../lib/auth.js';

export function renderNav() {
  const nav = document.getElementById('app-nav');
  if (!nav) return;

  nav.innerHTML = '';

  // Logo / Title
  const logo = document.createElement('a');
  logo.href = '#/explore';
  logo.className = 'nav-logo';
  logo.textContent = 'Unicode Mascot Animator';
  nav.appendChild(logo);

  // Nav links
  const links = document.createElement('div');
  links.className = 'nav-links';

  const exploreLink = document.createElement('a');
  exploreLink.href = '#/explore';
  exploreLink.className = 'nav-link';
  exploreLink.textContent = 'Explore';
  links.appendChild(exploreLink);

  const editorLink = document.createElement('a');
  editorLink.href = '#/editor';
  editorLink.className = 'nav-link';
  editorLink.textContent = 'Editor';
  links.appendChild(editorLink);

  const myAnimLink = document.createElement('a');
  myAnimLink.href = '#/my-animations';
  myAnimLink.className = 'nav-link nav-link-auth';
  myAnimLink.textContent = 'My Animations';
  myAnimLink.style.display = isAuthenticated() ? '' : 'none';
  links.appendChild(myAnimLink);
  onAuthChange(() => {
    myAnimLink.style.display = isAuthenticated() ? '' : 'none';
  });

  nav.appendChild(links);

  // Right side: auth placeholder (Phase 3)
  const right = document.createElement('div');
  right.className = 'nav-right';
  right.id = 'nav-auth';
  nav.appendChild(right);

  // Highlight active link on hash change
  function updateActive() {
    const hash = window.location.hash || '#/explore';
    nav.querySelectorAll('.nav-link').forEach(link => {
      const isActive = hash.startsWith(link.getAttribute('href'));
      link.classList.toggle('active', isActive);
    });
  }

  window.addEventListener('hashchange', updateActive);
  updateActive();
}
